import React, {useContext, useState} from "react";
import SignatureCanvas from "react-signature-canvas";
import axios from "axios";
import {Elink, SaveEstPortalSignUrl, SaveStorageSignatureUrl, SaveStorageAddendumSignatureUrl, For} from '../CommonComponents/Routes'
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import EstimateJobCharges from "../ClientPortal/EstimateJobCharges";

export default ({ mode = 'auto', addendumId = null, onSigned = null, buttonId = null } = {}) => {
    let RecordsController = useContext(RecordsManagementContext)
    let PageView = useContext(ViewMangementContext)
    let SignPad = {}
    const [saving, setSaving] = useState(false)
    const clear = () => {
        SignPad.clear()
        localStorage.setItem("loading", "no") //loading is set to "no" means loader is mot shown in place of the signature.
    }
    window.addEventListener('resize',()=>{
        if(window.innerHeight < window.innerWidth){
            document.getElementsByClassName('sign_estimate_modal')[0].style.top = "0% "
        }else{
            document.getElementsByClassName('sign_estimate_modal')[0].style.top = "16%"

        }
    })
    const saveSignature =  async () => {
        if (SignPad.isEmpty()) { // if sign not present it will show the alert message.
            PageView.setAlertProperty({
                Message: 'Please Sign before Submit the Signature...!',
                Type: 'warning',
                Show: true,
                AutoHide: true
            })
            localStorage.setItem("loading", "no")
        } else {
            setSaving(true)
            localStorage.setItem("loading", "yes") // loading is set to "yes" so that loader is shown in place of
            // signature until the signature will appears on the page.
            // Close modal immediately only for non-addendum modes
            if (!(mode === 'storage_addendum')) {
                RecordsController.setSignModal(false)
                RecordsController.setSignatureButtonShown(false)
                RecordsController.setShowSignatureModal(false)
            }
            let cookie = document.cookie.split('employee_id=')[1]
            const encoded = SignPad.toDataURL().replace('data:image/png;base64,', '')
            let requestConfig
            // Determine route based on mode: storage addendum vs storage portal vs estimate portal
            if (mode === 'storage_addendum' && addendumId) {
                requestConfig = { method: 'post', url: SaveStorageAddendumSignatureUrl, contentType: 'application/json', data: { Storage_key: Elink, employee_key: cookie, addendum_id: addendumId, encoded_image: encoded, picture_type: buttonId } }
            } else if (For === 'storage') {
                RecordsController.SetSP_PageDetails({
                    ...RecordsController.SP_PageDetails,
                    Header: { ...(RecordsController.SP_PageDetails.Header || {}), ShowSignStorage: false }
                })
                // storage portal signature save
                requestConfig = { method: 'post', url: SaveStorageSignatureUrl, contentType: 'application/json', data: { Storage_key: Elink, employee_key: cookie, encoded_image: encoded } }
            } else {
                requestConfig = { method: 'post', url: SaveEstPortalSignUrl, contentType: 'application/json', data: { estimate_key: Elink, employee_key: cookie, encoded_image: encoded } }
            }
              axios(requestConfig).then((response) => { // update the page view after post request is completed.
                  let Message = response.data.Message
                  if (Message && Message.Status === 'failed'){
                      localStorage.setItem("loading", "no");
                      window.location.reload();
                  }
                  else{
                      if (mode === 'storage_addendum') {
                          // On success of addendum signature, update SP_PageDetails to reflect signature for the selected addendum if backend returns it
                          localStorage.setItem("loading", "no")
                          PageView.setModalContent({Title: '', Body: '', Class: ''})
                          const updatedDetailed = (RecordsController.SP_PageDetails.AddendumsDetailed || []).map(a => {
                              if (a.id && addendumId && a.id.toString() === addendumId.toString()) {
                                  return { ...a, signed: true, signed_at: (response.data && response.data.signed_at) || new Date().toISOString() };
                              }
                              return a;
                          })
                          RecordsController.SetSP_PageDetails({ ...RecordsController.SP_PageDetails, AddendumsDetailed: updatedDetailed })
                          if (typeof onSigned === 'function') {
                            try { onSigned(response) } catch(e){ console.error('onSigned callback error', e) }
                          }
                          // now close modal after successful addendum signature
                          RecordsController.setSignModal(false)
                          RecordsController.setSignatureButtonShown(false)
                          RecordsController.setShowSignatureModal(false)
                      } else if (For === 'storage') {
                          // Update Storage Portal signature state
                          localStorage.setItem("loading", "no")
                          PageView.setModalContent({Title: '', Body: '', Class: ''})
                          const signatureInfo = response.data && response.data.StorageSignature ? response.data.StorageSignature : { Signed: true }
                          RecordsController.SetSP_PageDetails({
                              ...RecordsController.SP_PageDetails,
                              StorageSignature: { Signed: true, Url: signatureInfo.Url, UpdatedAt: signatureInfo.UpdatedAt || signatureInfo.Date }
                          })
                      } else {
                          localStorage.setItem("loading", "no")
                          PageView.setModalContent({Title: '', Body: '', Class: ''})
                          RecordsController.SetCP_PageDetails({
                              ...RecordsController.CP_PageDetails,
                              ClientPortalHeader: {
                                  ...RecordsController.CP_PageDetails.ClientPortalHeader,
                                  PortalSignature: {
                                      ...RecordsController.CP_PageDetails.ClientPortalHeader.PortalSignature,
                                      IsSignaturePresent: response.data[1].IsSignaturePresent}
                              },
                              EstimateDetails: {
                                  ...RecordsController.CP_PageDetails.EstimateDetails,
                                  JobDetails: {
                                      ...RecordsController.CP_PageDetails.EstimateDetails.JobDetails,
                                      JobDetails: {
                                          ...RecordsController.CP_PageDetails.EstimateDetails.JobDetails.JobDetails,
                                          ClientPortalSignId: response.data[0].JobDetails.ClientPortalSignId ,
                                          ClientPortalSignatureUpdatedAt: response.data[0].JobDetails.ClientPortalSignatureUpdatedAt,
                                          EstClientPortalSignature: response.data[0].JobDetails.EstClientPortalSignature,
                                          ShowSign: response.data[0].JobDetails.ShowSign,
                                          EventExist: response.data[0].JobDetails.EventExist,
                                          isAdmin: response.data[0].JobDetails.isAdmin}
                                  }
                              }
                          })
                      }
                  }
                  setSaving(false)
            }).catch(() => {
                 localStorage.setItem("loading", "no")
                 setSaving(false)
                 // For addendum keep modal open allowing retry
            })
        }
    }

    return (
        <div>
            {(() => { const companyName = For === 'storage' ? (RecordsController.SP_PageDetails.CompanyBranch && RecordsController.SP_PageDetails.CompanyBranch.Name) : RecordsController.CP_PageDetails.ClientPortalHeader.PortalSignature.CompanyBranchName; return (
                <p className='signPadContent'>
                    By signing this estimate electronically, you are agreeing to {companyName}'s terms and conditions stated herein.
                </p> ); })()}
            <div className="border-5 shadow py-2 px-2">
                <SignatureCanvas penColor='black' ref={(ref) => {
                    SignPad = ref
                }}
                                 canvasProps={{width: 900, height: 230, className: 'EstimateSignPad'}}/>
            </div>
            <div className='footer-btn'>
                <button className="btn btn-light m-2" onClick={() => clear()} disabled={saving}>CLEAR</button>
                <button className="btn btn-primary" disabled={saving} onClick={() => saveSignature()}>{ saving ? 'Saving...' : 'I AGREE'}</button>
            </div>
        </div>
    )
}